// Russian translations (Русский)
export const ru = {
  nav: {
    about: 'О нас',
    packages: 'Пакеты',
    technologies: 'Технологии',
    services: 'Услуги',
    process: 'Процесс',
    contact: 'Контакты',
    cta: 'Связаться'
  },
  
  hero: {
    title1: 'AI Консалтинг',
    title2: 'Новой Эры',
    subtitle: 'Автоматизация бизнеса и цифровая трансформация',
    description: 'Создаём интеллектуальные бизнес-системы с помощью AI. От анализа до полного внедрения.',
    ctaPrimary: 'Выбрать пакет',
    ctaSecondary: 'Консультация'
  },
  
  about: {
    title: 'Ваш партнёр в цифровой трансформации',
    paragraph1: 'Мир ускоряется. Компании, которые внедряют AI сегодня — становятся лидерами завтра.',
    paragraph2: 'От стратегии до полного внедрения — мы создаём интеллектуальные бизнес-системы с измеримым результатом.',
    whyChoose: 'Почему выбирают нас',
    benefits: [
      {
        title: 'Полный цикл — от стратегии до внедрения',
        description: 'Мы не просто консультируем — мы создаём рабочие решения. Анализируем, проектируем, внедряем и сопровождаем до результата.'
      },
      {
        title: 'Цифры, которые доказывают результат',
        description: 'Мы измеряем всё: время, эффективность, прибыль. KPI, ROI и BI-аналитика показывают, как AI делает ваш бизнес быстрее, точнее и прибыльнее.'
      },
      {
        title: 'AI — инструмент, а не будущее',
        description: 'Мы внедряем технологии, которые уже сегодня приносят прибыль бизнесу — от автоматизации задач до аналитики на основе данных.'
      },
      {
        title: 'Международный опыт и гибкость',
        description: 'Базируемся в Эстонии, работаем с клиентами по всему миру. Адаптируем решения под разные рынки и масштабы.'
      },
      {
        title: 'Партнёрство, а не подряд',
        description: 'Мы не просто консультанты — мы подключаемся к вашей команде и доводим проект до ощутимого эффекта.'
      }
    ]
  },
  
  packages: {
    title: 'Решения для цифрового роста',
    subtitle: 'От стратегии до автоматизации и внедрения AI',
    popular: 'Популярный',
    learnMore: 'Узнать больше',
    result: 'Результат:',
    items: [
      {
        name: 'INSIGHT',
        icon: '🔴',
        tagline: 'Анализ и стратегия роста',
        price: '€1 500 - €2 500',
        description: 'Для малого и среднего бизнеса, стартапов',
        features: [
          'Полный аудит бизнеса и процессов',
          'Анализ конкурентов и digital-зрелости',
          'SWOT-анализ и карта точек роста',
          'Рекомендации по AI и автоматизации',
          'Мини-стратегия на 3 месяца',
          'Стратегическая сессия (90 мин)'
        ],
        result: 'Понимание, где бизнес теряет деньги, и чёткий план роста'
      },
      {
        name: 'GROWTH ENGINE',
        icon: '🔵',
        tagline: 'Системный рост и автоматизация',
        price: '€4 500 - €9 000',
        description: 'Переход к системному росту и цифровизации',
        features: [
          'Всё из пакета INSIGHT',
          'Стратегия на 6 месяцев',
          'Внедрение CRM / ERP систем',
          'AI-чат-боты и автоворонки',
          'Сквозная аналитика и BI-дэшборды',
          'HR-консалтинг и внедрение KPI',
          '3 месяца сопровождения'
        ],
        result: 'Стабильный рост, прозрачное управление, автоматизация процессов',
        popular: true
      },
      {
        name: 'AI TRANSFORM',
        icon: '🟣',
        tagline: 'Цифровая трансформация бизнеса',
        price: '€12 000 - €30 000',
        description: 'Для среднего и крупного бизнеса',
        features: [
          'Всё из пакета GROWTH ENGINE',
          'Годовой Digital & AI roadmap',
          'Комплексная автоматизация процессов',
          'Внедрение AI-решений',
          'Модернизация IT-инфраструктуры',
          'Обучение персонала',
          'Индивидуальный куратор проекта'
        ],
        result: 'Полная AI-трансформация: масштабируемая экосистема на основе данных'
      },
      {
        name: 'PROJECT+',
        icon: '⚫',
        tagline: 'Индивидуальные решения',
        price: 'от €5 000',
        description: 'Кастомные проекты под ключ',
        features: [
          'AI-боты и ассистенты',
          'Автоматизация CRM/ERP',
          'Создание SaaS или маркетплейса',
          'BI-аналитика и прогнозирование',
          'Подготовка к инвестициям',
          'Интеграция AI в процессы'
        ],
        result: 'Готовое решение, адаптированное под ваши цели и масштаб'
      }
    ]
  },
  
  technologies: {
    title: 'Технологии и инструменты',
    subtitle: 'Передовые решения для автоматизации',
    items: [
      {
        title: 'Искусственный интеллект',
        description: 'Machine Learning, NLP, компьютерное зрение, предиктивная аналитика',
        keywords: ['ChatGPT', 'Claude', 'Gemini', 'Custom AI']
      },
      {
        title: 'Автоматизация процессов',
        description: 'RPA, workflow automation, интеграции API, бизнес-процессы',
        keywords: ['Make', 'Zapier', 'n8n', 'Custom Scripts']
      },
      {
        title: 'CRM & ERP системы',
        description: 'Внедрение, настройка и оптимизация систем управления',
        keywords: ['Bitrix24', 'Salesforce', 'SAP', '1C']
      },
      {
        title: 'BI & Аналитика',
        description: 'Business Intelligence, дэшборды, визуализация данных',
        keywords: ['Power BI', 'Tableau', 'Looker', 'Custom']
      }
    ]
  },
  
  services: {
    title: 'Наши направления',
    subtitle: 'Комплексные решения для роста бизнеса',
    items: [
      { title: 'Бизнес-консалтинг', description: 'Стратегическое планирование, оптимизация процессов, увеличение прибыли' },
      { title: 'Digital трансформация', description: 'Цифровизация бизнеса, внедрение современных технологий, масштабирование' },
      { title: 'Финансовый консалтинг', description: 'Финансовый анализ, оптимизация расходов, планирование и управление рисками' },
      { title: 'Юридическое сопровождение', description: 'Корпоративное право, договоры, GDPR, международное законодательство' },
      { title: 'HR-консалтинг', description: 'Управление персоналом, KPI, мотивация команды, развитие талантов' },
      { title: 'Автоматизация', description: 'Автоматизация бизнес-процессов, интеграции, повышение эффективности' },
      { title: 'AI & ML внедрение', description: 'Искусственный интеллект для бизнеса, аналитика, прогнозирование, чат-боты' }
    ]
  },
  
  whyUs: {
    title: 'Результаты, которые говорят сами за себя',
    subtitle: 'Цифры нашей эффективности',
    items: [
      { prefix: 'до', number: '92%', title: 'Рост эффективности', description: 'Средний прирост производительности после внедрения наших решений' },
      { prefix: 'до', number: '6 мес', title: 'Окупаемость', description: 'Средний срок возврата инвестиций в автоматизацию и AI' },
      { number: '24/7', title: 'Поддержка', description: 'Техническая поддержка и консультации на всех этапах' },
      { prefix: '> ', number: '50', title: 'Проектов', description: 'Успешно реализованных AI и automation проектов' }
    ]
  },
  
  process: {
    title: 'Процесс работы',
    subtitle: 'От анализа до результата',
    items: [
      { number: '01', title: 'Анализ и аудит', description: 'Глубокий анализ бизнеса, процессов и текущих систем' },
      { number: '02', title: 'Стратегия', description: 'Разработка roadmap и плана цифровой трансформации' },
      { number: '03', title: 'Внедрение', description: 'Поэтапное внедрение AI, автоматизации и систем управления' },
      { number: '04', title: 'Обучение', description: 'Обучение персонала работе с новыми технологиями' },
      { number: '05', title: 'Оптимизация', description: 'Непрерывное улучшение и масштабирование решений' }
    ]
  },
  
  contact: {
    title: 'Свяжитесь с нами',
    subtitle: 'Готовы начать трансформацию вашего бизнеса?',
    selectedPackage: 'Выбранный пакет:',
    goalQuestion: 'Какова основная цель вашего запроса?',
    goals: ['Автоматизация процессов', 'Внедрение AI', 'Повышение эффективности', 'Консалтинг'],
    multipleChoice: 'Можно выбрать несколько вариантов',
    form: {
      name: 'Имя *',
      email: 'Email *',
      company: 'Название компании *',
      companyDescription: 'Краткое описание чем занимается компания *',
      message: 'Дополнительное сообщение (опционально)',
      terms: 'Я ознакомлен и согласен с',
      termsLink: 'условиями использования',
      and: 'и',
      privacyLink: 'политикой конфиденциальности',
      termsNote: '*. При заказе услуг по любому каналу (e-mail, телефон и т.д.) вы автоматически соглашаетесь с нашими условиями использования.',
      submit: 'Отправить сообщение',
      submitting: 'Отправка...',
      success: 'Спасибо! Мы свяжемся с вами в ближайшее время.',
      error: 'Произошла ошибка. Пожалуйста, попробуйте позже.'
    }
  },
  
  footer: {
    description: 'Консалтинг нового поколения. AI, автоматизация и цифровая трансформация бизнеса.',
    company: 'Polyus Plus OÜ',
    navigation: 'Навигация',
    legal: 'Правовая информация',
    links: {
      about: 'О нас',
      packages: 'Пакеты',
      services: 'Услуги',
      contact: 'Связаться с нами',
      terms: 'Условия оказания услуг',
      privacy: 'Политика конфиденциальности',
      cookie: 'Cookie Policy',
      cookieSettings: 'Настройки cookies'
    },
    rights: 'Все права защищены.',
    keywords: 'AI консалтинг | Автоматизация бизнеса | Цифровая трансформация'
  },
  
  cookie: {
    title: '🍪 Уведомление о cookies',
    description: 'Мы используем файлы cookie для улучшения вашего опыта и аналитики.',
    accept: 'Принять',
    decline: 'Отклонить',
    settings: 'Настройки',
    moreDetails: 'Подробнее →',
    settingsModal: {
      title: 'Настройки cookies',
      subtitle: 'Выберите, какие cookies разрешить',
      alwaysEnabled: 'Всегда включены',
      saveSettings: 'Сохранить настройки',
      acceptAll: 'Принять все',
      categories: {
        essential: {
          name: 'Необходимые cookies',
          description: 'Эти cookies необходимы для работы сайта и не могут быть отключены.'
        },
        analytics: {
          name: 'Аналитические cookies',
          description: 'Google Analytics 4, Hotjar - помогают понять, как посетители используют сайт.'
        },
        marketing: {
          name: 'Маркетинговые cookies',
          description: 'Meta Pixel, TikTok Pixel - используются для таргетированной рекламы.'
        },
        functional: {
          name: 'Функциональные cookies',
          description: 'Улучшают функциональность сайта (сохранение языка, темы и т.д.).'
        }
      }
    }
  },
  
  // Meta and SEO
  meta: {
    title: 'Polyus Plus | AI Консалтинг и Автоматизация Бизнеса в Таллинне, Эстония',
    description: 'Профессиональный AI консалтинг, автоматизация бизнес-процессов и цифровая трансформация. Внедрение искусственного интеллекта, увеличение эффективности до 92%, прозрачный ROI. Консалтинг в Таллинне, работаем по всему миру.',
    keywords: 'AI консалтинг, автоматизация бизнеса, цифровая трансформация, внедрение AI, бизнес процессы, консалтинг Эстония, Таллинн, искусственный интеллект, KPI, ROI, эффективность бизнеса, Google Analytics 4, Hotjar, Facebook Pixel',
    ogTitle: 'Polyus Plus | AI Консалтинг и Автоматизация Бизнеса',
    ogDescription: 'Профессиональный AI консалтинг, автоматизация бизнес-процессов и цифровая трансформация. Увеличение эффективности до 92%, прозрачный ROI.',
    siteName: 'Polyus Plus',
    footer: {
      company: 'О компании',
      about: 'О нас',
      packages: 'Пакеты',
      services: 'Услуги',
      contact: 'Связаться с нами',
      terms: 'Условия оказания услуг',
      privacy: 'Политика конфиденциальности',
      cookie: 'Cookie Policy',
      cookieSettings: 'Настройки cookies'
    },
    rights: 'Все права защищены.'
  }
};
